<hr>
<nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a class="nav-item nav-link active min" id="nav-valorizado-tab" data-toggle="tab" href="#nav-valorizado" role="tab" aria-controls="nav-valorizado" aria-selected="true"></a>
        <!-- <a class="nav-item nav-link min" id="nav-novalorizado-tab" data-toggle="tab" href="#nav-novalorizado" role="tab" aria-controls="nav-novalorizado" aria-selected="false">No Valorizado</a> -->
    </div>
</nav>

<div class="tab-content" id="nav-tabContent">

    <div class="tab-pane fade show active" id="nav-valorizado" role="tabpanel" aria-labelledby="nav-valorizado-tab">
        <div class="preloader2" *ngIf="cargando">
            <div class="loader2">
                <p class="loader__label2">
                    <img src="assets/images/Double Ring-1s-200px.gif" style="background: transparent !important;" />
                </p>
            </div>
        </div>
        <div class="col-12 row" style="margin-top: 40px;">
            <div class="col-6" style="margin-bottom: 10px;display: flex;">

                <div class="form-group col-6">
                    <label style="font-size: 12px" class="color-page-i">Buscar fecha de documento desde:</label>
                    <input type="date" class="form-control form-control-sm" name="fecha_documento_inicio_cliente"
                           [(ngModel)]="documento_cpe.fecha_inicio" (ngModelChange)="funclsDocuxfechaIni()">

                </div>
                <div class="form-group col-6">
                    <label style="font-size: 12px" class="color-page-i">Buscar fecha de documento hasta:</label>
                    <input type="date" class="form-control form-control-sm" name="fecha_documento_fin_cliente"
                           [(ngModel)]="documento_cpe.fecha_fin" (ngModelChange)="funclsDocuxfecha()">

                </div>
            </div>
            <div class="col-6 row">
                <div class="form-group col-6">
                    <label style="font-size: 12px" class="color-page-i">Seleccione el tipo de documentovic :</label>
                    <ng-select [items]="lstipodocumentos" bindLabel="descripcion" bindValue="codigosunat" placeholder="seleccione" [(ngModel)]="tdoc" (ngModelChange)="listarDocumento()"></ng-select>
                </div>
                <div class="form-group col-6">
                    <label style="font-size: 12px" class="color-page-i">Seleccione un estado :</label>
                    <ng-select [items]="lsEstadoDocumento" bindLabel="estado" bindValue="codigo" placeholder="seleccione" [(ngModel)]="tEstado" (ngModelChange)="listarDocumento()"></ng-select>
                </div>

                <div style="margin-right: auto;margin-top: 3%; margin-left: 281px;" *ngIf="valIcons">
                    <button (click)="botonHabilitarResumen()" type="button" class="btn btn-danger btn-sm min" style="width: 110px;">Habilitar resumen</button>
                </div>
                <div style="margin-top: 3%;" *ngIf="valIcons">
                    <button (click)="enviarlsDoc()" type="button" class="btn btn-success btn-sm min" [disabled]="!valbuton">Enviar resumen</button>
                </div>
            </div>

        </div>
        <div class="col-12 row" style="margin-top: 40px;">
            <!-- <div class="col-4" style="margin-bottom: 10px">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="SearchOptions" id="guia" (click)="checkAction()" onclick="document.getElementById('inputGeneral').value='';" checked>
                    <label class="form-check-label color-page-i" for="guia" style="font-size: 12px">Buscar por Documento</label>
                </div>
                <input class="form-control form-control-sm min" id="inputGeneral" type="text" [(ngModel)]="filterPost" placeholder="{{mostrarCD}}" style="border-radius: 28px">
            </div> -->
            <div class="col-6" style="margin-bottom: 10px">
                <mat-form-field style="width: 335px; margin-right: 90px;">
                    <mat-label>Buscar...</mat-label>
                    <input matInput (keyup)="applyFilter($event)" #input>
                </mat-form-field>
            </div>
            <div class="col-6" style="margin-bottom: 10px; padding-top: 28px;">
                <button class="btn btn-success" id="btnExportar" (click)="fireEvent()" style="margin-top: -24px;margin-left: -27%;">
                    <i class="mdi mdi-file-excel" style="padding-right: 10px;"></i>Exportar</button>
            </div>
        </div>
        <div class="table-responsive" style="opacity: 0.9; border-radius: 15px; box-shadow: 2px 1px 26px 0px rgba(0,0,0,0.35);">
            <mat-progress-bar mode="indeterminate" *ngIf="progressTable"></mat-progress-bar>
            <table mat-table [dataSource]="lsDocumentosFac" matSort multiTemplateDataRows style="width: 100%;">

                <ng-container matColumnDef="tipo_doc">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-weight: normal; font-size: 12px; color: #ffffff;">Tipo Documento </th>
                    <td mat-cell *matCellDef="let element" (click)="previsualizarDocu(element,documento_cpe.visualizar=true)" class="text-center">
                        {{element.tipo_doc }}</td>
                </ng-container>

                <ng-container matColumnDef="documento">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-weight: normal; font-size: 12px; color: #ffffff;">Documento </th>
                    <td mat-cell *matCellDef="let element" (click)="previsualizarDocu(element,documento_cpe.visualizar=true)" class="text-center">
                        {{element.serie_comprobante}} - {{element.nro_comprobante}}</td>
                </ng-container>

                <ng-container matColumnDef="doc_referencia">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-weight: normal; font-size: 12px; color: #ffffff;">Documento de referencia </th>
                    <td mat-cell *matCellDef="let element" (click)="previsualizarDocu(element,documento_cpe.visualizar=true)" class="text-center">
                        {{element.cod_tipo_documento==07?element.nro_documento_modifica:"-"}}</td>
                </ng-container>

                <ng-container matColumnDef="proveedor">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center;font-weight: normal; font-size: 12px; color: #ffffff;"> Proveedor
                    </th>
                    <td mat-cell *matCellDef="let element" (click)="previsualizarDocu(element,documento_cpe.visualizar=true)" style="text-align: center;">
                        {{element.clientes.razon_social}} </td>
                </ng-container>

                <ng-container matColumnDef="fechadocumento">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center;font-weight: normal; font-size: 12px; color: #ffffff;"> Fecha del documento </th>
                    <td mat-cell *matCellDef="let element" (click)="previsualizarDocu(element,documento_cpe.visualizar=true)" style="text-align: center;">
                        {{element.fecha_documento | fechaDoc:'d/M/yyyy' }}</td>
                </ng-container>

                <ng-container matColumnDef="total">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center;font-weight: normal; font-size: 12px; color: #ffffff;"> Total </th>
                    <td mat-cell *matCellDef="let element" (click)="previsualizarDocu(element,documento_cpe.visualizar=true)" style="text-align: center;">
                        {{element.total }}</td>
                </ng-container>

                <ng-container matColumnDef="generarnotacredito">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: normal; font-size: 12px; color: #ffffff;"> Generar Nota Credito </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                        <button (click)="previsualizarDocu(element,documento_cpe.visualizar=false)" style="background: #f0f8ff00;border: #f0f8ff00;" [disabled]="element.referencia=='doc_referencia'">
                            <i *ngIf="!(element.cod_tipo_documento=='07' || element.cod_tipo_documento=='08' || element.cod_tipo_documento=='09' || element.cod_tipo_documento=='31')"
                                class="mdi mdi-file-document color-page-i" aria-hidden="true"
                                style="cursor: pointer;font-size: 20px"></i>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="consultarestado">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: normal; font-size: 12px; color: #ffffff;"> Consultar Estado </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                        <i *ngIf="empresadat.ifacturacionpse==0?true:false" (click)="openModalEstadoDocumento(element)" class="fa fa-file-text-o color-page-i" aria-hidden="true" style="cursor: pointer;font-size: 20px"></i>
                    </td>
                </ng-container>

                <ng-container matColumnDef="darbaja">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: normal; font-size: 12px; color: #ffffff;"> Dar de baja
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                        <i *ngIf="element.cod_tipo_documento != '09' && element.cod_tipo_documento != '31'" (click)="openModalObservaciones(element)" class="mdi mdi-block-helper color-page-i" aria-hidden="true" style="cursor: pointer;font-size: 20px"></i>
                    </td>
                </ng-container>

                <ng-container matColumnDef="reporte">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: normal; font-size: 12px; color: #ffffff;"> Reporte </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                        <i *ngIf="element.estado == 1 || element.estado == 2" (click)="print(element)" class="mdi mdi-file-pdf color-page-i" aria-hidden="true" style="cursor: pointer;font-size: 20px"></i>
                    </td>
                </ng-container>

                <ng-container matColumnDef="enviaremail">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: normal; font-size: 12px; color: #ffffff;"> Enviar email
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                        <i (click)="openModalCorreo(element)" class="mdi mdi-email color-page-i" aria-hidden="true" style="cursor: pointer;font-size: 20px"></i>
                    </td>
                </ng-container>

                <ng-container matColumnDef="cpe">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: normal; font-size: 12px; color: #ffffff;padding-right: 5px;">
                        CPE </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                        <i (click)="descargarDocumentoCPE(element,'CPE')" class="mdi mdi-file-xml color-page-i" aria-hidden="true" style="cursor: pointer;font-size: 20px;"></i>
                    </td>
                </ng-container>

                <ng-container matColumnDef="cdr">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: normal; font-size: 12px; color: #ffffff;padding-right: 5px;">
                        CDR </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                        <i (click)="descargarDocumentoCPE(element,'CDR')" class="mdi mdi-file-xml color-page-i" aria-hidden="true" style="cursor: pointer;font-size: 20px;"></i>
                    </td>
                </ng-container>

                <ng-container matColumnDef="archivo">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: normal; font-size: 12px; color: #ffffff;"> ARCHIVO </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                        <i (click)="nuevoArchivo(element)" class="mdi mdi-file-pdf color-page-i" aria-hidden="true" style="cursor: pointer;font-size: 20px"></i>
                    </td>
                </ng-container>

                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                        <div class="example-element-detail" *ngIf="element.ls_documentoCpe.length > 0" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'" style="opacity: 0.9; border-radius: 15px; box-shadow: 2px 1px 26px 0px rgba(0,0,0,0.35);">

                            <table mat-table [dataSource]="element.ls_documentoCpe" class="mat-elevation-z8" style="width: 100% !important; margin: auto;">

                                <ng-container matColumnDef="descripcion">
                                    <th mat-header-cell *matHeaderCellDef style="font-weight: normal; font-size: 12px; color: #ffffff;"> Descripcion </th>
                                    <td mat-cell *matCellDef="let elem"> {{elem.descripcion}} </td>
                                </ng-container>


                                <ng-container matColumnDef="unidadmedida">
                                    <th mat-header-cell *matHeaderCellDef style="font-weight: normal; font-size: 12px; color: #ffffff;"> Unidad de Medida
                                    </th>
                                    <td mat-cell *matCellDef="let elem"> {{elem.unidad_medida}} </td>
                                </ng-container>

                                <ng-container matColumnDef="cantidad">
                                    <th mat-header-cell *matHeaderCellDef style="font-weight: normal; font-size: 12px; color: #ffffff;"> Cantidad </th>
                                    <td mat-cell *matCellDef="let elem"> {{elem.cantidad}} </td>
                                </ng-container>

                                <ng-container matColumnDef="precio">
                                    <th mat-header-cell *matHeaderCellDef style="font-weight: normal; font-size: 12px; color: #ffffff;"> Precio </th>
                                    <td mat-cell *matCellDef="let elem"> {{elem.precio}} </td>
                                </ng-container>

                                <ng-container matColumnDef="importe">
                                    <th mat-header-cell *matHeaderCellDef style="font-weight: normal; font-size: 12px; color: #ffffff;"> Importe </th>
                                    <td mat-cell *matCellDef="let elem"> {{elem.importe}} </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsVersion" class="color-page-tr">
                                </tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsVersion;"></tr>
                            </table>
                        </div>
                    </td>
                </ng-container>
                <!-- <ng-container matColumnDef="seleccionar" *ngIf="lsCheck">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Seleccionar </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                        <input class="form-check-input" type="checkbox" id="{{element}}" [(ngModel)]="element.valSend" (ngModelChange)="enviarCheck(element.valSend,element.id_documento)">
                        <label class="form-check-label" for="{{element}}"></label>
                    </td>
                </ng-container> -->
                <!-- <ng-container matColumnDef="header-row-second-group">
                    <th mat-header-cell *matHeaderCellDef [attr.colspan]="2"> Documento </th>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="['header-row-second-group']"></tr> -->

                <tr mat-header-row *matHeaderRowDef="displayedColumns" class="color-page-tr"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row" [class.example-expanded-row]="expandedElement === row" (click)="expandedElement = expandedElement === row ? null : row">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>

            <mat-paginator [pageSize]="cantidad_registros" [length]="total_documentos" (page)="pageEvent = funcPaginator($event)" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>

<!-- <app-nuevo-registro2 (DocuLis)="display($event)"></app-nuevo-registro2> -->